import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Smartphone } from "lucide-react";

export default function DesktopAccessQr() {
  const [qrDataUrl, setQrDataUrl] = useState(null);
  const [accessUrl, setAccessUrl] = useState("");

  useEffect(() => {
    const url = window.location.href;
    setAccessUrl(url);
    let cancelled = false;
    QRCode.toDataURL(url, {
      width: 200,
      margin: 1,
      color: { dark: "#18181b", light: "#ffffff" },
    })
      .then((dataUrl) => {
        if (!cancelled) setQrDataUrl(dataUrl);
      })
      .catch(() => {
        if (!cancelled) setQrDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <aside
      className="hidden sm:flex flex-col items-center max-w-[220px] text-center shrink-0"
      data-testid="desktop-access-qr"
    >
      <div className="flex items-center gap-2 mb-4">
        <Smartphone className="w-4 h-4 text-orange-500" />
        <p className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-600 dark:text-zinc-400">
          Acceso móvil
        </p>
      </div>
      <div className="p-3 bg-white dark:bg-zinc-900 rounded-md border border-zinc-200 dark:border-zinc-800 shadow-sm">
        {qrDataUrl ? (
          <img
            src={qrDataUrl}
            alt="Código QR para abrir en el móvil"
            width={200}
            height={200}
            className="block"
            data-testid="desktop-access-qr-image"
          />
        ) : (
          <div
            className="w-[200px] h-[200px] bg-zinc-100 dark:bg-zinc-800 animate-pulse rounded-sm"
            data-testid="desktop-access-qr-loading"
          />
        )}
      </div>
      <p className="mt-4 font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500 dark:text-zinc-500 leading-relaxed">
        Escanea para abrir esta página en tu teléfono
      </p>
      <p
        className="mt-2 font-mono-tech text-[9px] text-zinc-400 dark:text-zinc-600 break-all line-clamp-3"
        title={accessUrl}
      >
        {accessUrl}
      </p>
    </aside>
  );
}
